import React, { useState, useCallback, useEffect } from "react";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const BrochureContext = React.createContext({
  state: { brochureList: {}, brochure: {} },
  actions: {
    getBrochure: () => {},
    getBrochureList: () => {},
  },
});

const BrochureProvider = ({ children }) => {
  const [brochure, setBrochure] = useState([]);
  const [brochureList, setBrochureList] = useState([]);
  
  const getBrochure = useCallback((brochureId) => {
    HttpAction({
      url: "api/admin/brochure",
      method: "get",
      params: {
        brochureId: brochureId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setBrochure(res.data);
      } else {
      }
    });
  }, []);

  const getBrochureList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/admin/brochure/list", 
      method: "get",
      params: {
        brochureContent: pageInfo && pageInfo.brochureContent,
        brochureYear: pageInfo && pageInfo.brochureYear,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
      }
    }).then((res) => {
      if (res.code === 200) {
        setBrochureList(res.data);
      } else {
      }
    });
  }, []);

  const createBrochure = useCallback((brochureData,setState) => {
    HttpAction({
      url: "api/admin/brochure/save",
      method: "post",
      data: {
        brochureYear: brochureData.brochureYear,
        brochureMonth: brochureData.brochureMonth,
        brochureContent: brochureData.brochureContent,
        brochureContent2: brochureData.brochureContent2,
        brochureContent3: brochureData.brochureContent3,
        brochureContent4: brochureData.brochureContent4,
      }
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        })
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const updateBrochure = useCallback((brochureData, setState) => {
    HttpAction({
      url: "api/admin/brochure/modify",
      method: "post",
      data: {
        brochureYear: brochureData.brochureYear,
        brochureMonth: brochureData.brochureMonth,
        brochureContent: brochureData.brochureContent,
        brochureContent2: brochureData.brochureContent2,
        brochureContent3: brochureData.brochureContent3,
        brochureContent4: brochureData.brochureContent4,
        brochureId: brochureData.brochureId,
      }
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        })
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const deleteBrochure = useCallback((brochureId, history, url ) => {
    HttpAction({
      url: "api/admin/brochure",
      method: "delete",
      params: {
        brochureId: brochureId
      }
    }).then((res) => {
      if (res.code === 200) {
      history.push(url)
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { brochure, brochureList },
    actions: { getBrochure, getBrochureList, createBrochure, updateBrochure, deleteBrochure },
  };

  return (
    <BrochureContext.Provider value={value}>
      {children}
    </BrochureContext.Provider>
  );
};

const { Consumer: BrochureConsumer } = BrochureContext;

export { BrochureProvider, BrochureConsumer, BrochureContext };

export default BrochureContext;
